export default __webpack_public_path__ + "static/media/ground_beef.e9c31ae3.png";